import { useAccountBalanceStrings } from "module/vault/hook/useAccountBalanceStrings"

import { SimpleGrid, Text, VStack } from "@chakra-ui/react"
import { Card } from "component/Card"
import { Stats } from "component/Stats"
import { useEffect, useState } from "react"

import { formatMarginRatio } from "../../../util/formatMarginRatio"
import { RiskBar } from "./RiskBar"

function RiskCard() {
    const { marginRatioVal, leverageStr } = useAccountBalanceStrings()
    const [marginRatioColor, setMarginRatioColor] = useState("white")
    const [riskSuggestion, setRiskSuggestion] = useState("Margin Ratio will show up once you have a position.")

    useEffect(() => {
        if (marginRatioVal !== 0 && marginRatioVal <= 100) {
            setMarginRatioColor("white")
            setRiskSuggestion("Low risk: you're going to get a good night’s sleep.")
        }
        if (marginRatioVal !== 0 && marginRatioVal <= 0.5) {
            setMarginRatioColor("rgba(255,180,89,1)")
            setRiskSuggestion("Medium risk: keep your margin ratio above 6.25% to avoid liquidation.")
        }
        if (marginRatioVal !== 0 && marginRatioVal <= 0.0625) {
            setMarginRatioColor("rgba(241,103,105,1)")
            setRiskSuggestion(
                "High risk: your positions are at risk of being liquidated! Add more funds to avoid liquidation!",
            )
        }
        // TODO: handle loading or no position scenarios
    }, [marginRatioVal])

    return (
        <Card sx={{ userSelect: "none" }}>
            <VStack spacing={4} align="stretch">
                <SimpleGrid columns={2} width="100%">
                    <Stats
                        size="2xl"
                        labelColor="rgba(255,255,255,0.75)"
                        label="Margin Ratio"
                        numberColor={marginRatioColor}
                        number={formatMarginRatio(marginRatioVal)}
                    />
                    <Stats size="2xl" labelColor="rgba(255,255,255,0.75)" label="Leverage" number={leverageStr} />
                </SimpleGrid>
                <Text h={{ base: "auto", lg: "64px" }} color="gray.400" fontSize="sm">
                    {riskSuggestion}
                </Text>
                <RiskBar />
            </VStack>
        </Card>
    )
}

export { RiskCard }
